import { SET_APP_CONFIG } from '../actions/const';

const initialState = {
	showModal: false,
	isLoadingAction: false,

	formType: '',
	formTitle: '',

	evoucherNotif_isLoading: false,

	evoucherNotif_dailyNotifAM_hh: '',
	evoucherNotif_dailyNotifAM_hh_parseObject: null,

	evoucherNotif_dailyNotifAM_mm: '',
	evoucherNotif_dailyNotifAM_mm_parseObject: null,

	evoucherNotif_dailyNotifPM_hh: '',
	evoucherNotif_dailyNotifPM_hh_parseObject: null,

	evoucherNotif_dailyNotifPM_mm: '',
	evoucherNotif_dailyNotifPM_mm_parseObject: null,

	evoucherNotif_dailyAM: '',
	evoucherNotif_dailyPM: '',

	//

	showsNotif_isLoading: false,

	showsNotif_dailyNotif_hh: '',
	showsNotif_dailyNotif_hh_parseObject: null,

	showsNotif_dailyNotif_mm: '',
	showsNotif_dailyNotif_mm_parseObject: null,

	showsNotif_dailyNotif_ss: '',
	showsNotif_dailyNotif_ss_parseObject: null,

	showsNotif_form_dailyNotif_hh: '',
	showsNotif_form_dailyNotif_mm: '',
	showsNotif_form_dailyNotif_ss: '',

	//

	menu_isLoading: false,

	menu_isTierPointsEnabled: false,
	menu_isTierPointsEnabled_parseObject: null,

	menu_form_isTierPointsEnabled: false,

	menu_isGVEnabled: false,
	menu_isGVEnabled_parseObject: null,

	menu_form_isGVEnabled: false,

	menu_isCalypsoEnabled: false,
	menu_isCalypsoEnabled_parseObject: null,

	menu_form_isCalypsoEnabled: false,

	menu_isRaffleDrawEnabled: false,
	menu_isRaffleDrawEnabled_parseObject: null,
	menu_form_isRaffleDrawEnabled: false,

	menu_isInvitationsEnabled: false,
	menu_isInvitationsEnabled_parseObject: null,
	menu_form_isInvitationsEnabled: false,
	//

	card_isLoading: false,

	card_isQRCodeEnabled: false,
	card_isQRCodeEnabled_parseObject: null,

	card_form_isQRCodeEnabled: false,

	string_isLoading: false,

	string_casinoPromotionsUrl: '',
	string_casinoPromotionsUrl_parseObject: null,

	string_lifestyleUrl: '',
	string_lifestyleUrl_parseObject: null,

	string_directoryUrl: '',
	string_directoryUrl_parseObject: null,

	string_shuttleUrl: '',
	string_shuttleUrl_parseObject: null,

	string_nwrHotline: '',
	string_nwrHotline_parseObject: null,

	string_winfordHotline: '',
	string_winfordHotline_parseObject: null,

	string_epicMillionsSecretKey: '',
	string_epicMillionsSecretKey_parseObject: null,

	string_formStateKey: '',
	string_formInput: '',
};

function reducer(state = initialState, action) {
	let { type, payload } = action;

	switch (type) {
		case SET_APP_CONFIG:
			if (typeof action.payload.resetState !== 'undefined' && action.payload.resetState) {
				action.payload = { ...initialState };
			}
			return Object.assign({}, state, action.payload);
			break;

		default: {
			return state;
		}
	}
}

module.exports = reducer;



// WEBPACK FOOTER //
// ./reducers/AppConfig.js